class DeviceDetector {
  isIOS() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone/.test(userAgent);
  }

 

  // Проверяем, является ли пользователь владельцем iOS устройства
  isIOSOwner() {
    return this.isIOS();
  }
}

export const deviceDetector = new DeviceDetector(); 